import type { RemixContentComponentDefinition } from '@atlassian/malleable-ui-components/types';
import { hasRemixableContent } from '@atlassian/malleable-ui-components/editor-remix/remix-fragment';

import {
	createRemixContentComponentPlatform,
	EditorRemixLifecycleAdapterHost,
	isNodeUnsupportedForConfluenceRemix,
} from './EditorRemixCreatorPlatform.tsx';

/**
 * Creates a content component for RemixContentComponent using RemixContainer.
 *
 * The returned definition keeps the platform implementation and its
 * lifecycle-adapter capability together, so editor hosts do not need to
 * inspect the implementation to discover it.
 */
export const createRemixContentComponent = (): RemixContentComponentDefinition => ({
	Component: createRemixContentComponentPlatform(),
	LifecycleHost: EditorRemixLifecycleAdapterHost,
	isSelectionRemixable: (fragment) =>
		hasRemixableContent(fragment, isNodeUnsupportedForConfluenceRemix),
	capabilities: {
		editorRemixLifecycleAdapter: true,
	},
});
